import { useEffect, useState, useCallback } from "react";
import dataService from "../../../helpers/dataService";
import { toast } from "react-toastify";

const useRelanceRDO = (allocataireId) => {
  const [peutEnvoyer, setPeutEnvoyer] = useState(false);
  const [erreur, setErreur] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const [envoyeData, setEnvoyeData] = useState(null);

  // Vérifier si on peut envoyer une relance
  const checkPeutEnvoyer = useCallback(() => {
    if (!allocataireId) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    dataService.get(
      `rdo/relances/peut-envoyer-a?allocataireId=${allocataireId}`,
      (response) => {
        setPeutEnvoyer(response.peutEnvoyer);
        setErreur(response.erreur || null);
        setIsLoading(false);
      },
      (error) => {
        console.error("Erreur lors de la vérification:", error);
        setErreur("Erreur lors de la vérification");
        setPeutEnvoyer(false);
        setIsLoading(false);
      }
    );
  }, [allocataireId]);

  // Envoyer une relance
  const envoyerRelance = () => {
    if (!allocataireId || !peutEnvoyer) return;
    if (
      !window.confirm(
        "L'allocataire recevra un email d'invitation à compléter le RDO. Confirmez-vous cette action ?"
      )
    )
      return;

    setIsSending(true);
    dataService.post(
      "rdo/relances/envoyer-a",
      { allocataireId },
      (response) => {
        toast.success(
          `Relance envoyée avec succès ! Lot: ${response.numeroLot} (${
            response.nbAllocataires
          } allocataire${response.nbAllocataires > 1 ? "s" : ""})`
        );
        setEnvoyeData(response);
        setIsSending(false);
        // Ne pas recharger l'état pour garder le message d'envoi
      },
      (error) => {
        console.error("Erreur lors de l'envoi de la relance:", error);
        toast.error("Erreur lors de l'envoi de la relance");
        setIsSending(false);
      }
    );
  };

  // Vérifier au chargement du composant
  useEffect(() => {
    checkPeutEnvoyer();
  }, [allocataireId, checkPeutEnvoyer]);

  return {
    peutEnvoyer,
    erreur,
    isLoading,
    isSending,
    envoyerRelance,
    checkPeutEnvoyer,
    envoyeData,
  };
};

export default useRelanceRDO;
